import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';

@NgModule({
    imports: [CommonModule],
    declarations: [SlickGridComponent],
    exports: [SlickGridComponent]
})
export class SlickGridModule {

}


// WEBPACK FOOTER //
// ./src/app/slick-grid/slick-grid.module.ts